import { render, staticRenderFns } from "./geolocation.vue?vue&type=template&id=5385a809&scoped=true"
import script from "./geolocation.vue?vue&type=script&lang=js"
export * from "./geolocation.vue?vue&type=script&lang=js"
import style0 from "./geolocation.scss?vue&type=style&index=0&id=5385a809&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385a809",
  null
  
)

export default component.exports